import React, {useMemo} from 'react';
import {PageInterface, ProductLayout} from '@taopix/taopix-core/dist/types/types';
import classNames from 'classnames';
import {getPageName} from '../../Utils/Common';
import useViewMode from '../../Hooks/useViewMode';
import {CollectionType, ViewMode} from '@taopix/taopix-core';
import {useExperience} from '../Experience/ExperienceProvider';

export type PageNameProps = {
  page: PageInterface;
  layout: ProductLayout;
};

const PageName = ({page, layout}: PageNameProps) => {
  const [viewMode] = useViewMode();
  const {experience} = useExperience();

  const showPageActionButtons = useMemo(() => {
    switch (viewMode) {
      case ViewMode.Grid: {
        // there is no experience for this????
        return true;
      }
      case ViewMode.List: {
        return experience.EDITOR.workArea.listView.pageActionButtons;
      }
      case ViewMode.Single: {
        return experience.EDITOR.workArea.singlePage.pageActionButtons;
      }
      default: {
        return false;
      }
    }
  }, [viewMode, experience]);

  const pageNameClasses = classNames(
    'justify-around',
    'sm:mx-auto',
    'opacity-40',
    'text-sm',
    'break-words',
    'text-center',
    showPageActionButtons && 'sm:max-w-[calc(100%-60px)]',
    viewMode === ViewMode.Grid ? 'text-center line-clamp-2 overflow-ellipsis' : 'flex'
  );

  return (
    <p className={pageNameClasses}>
      {getPageName(page, layout, layout.type === CollectionType.Calendar)}
    </p>
  );
};

export default PageName;
